import {Fab, Grid} from '@material-ui/core';
import {Link} from 'react-router-dom';
import {CardStyles} from '../Cards/CardStyles';
import {GroupCard} from '../Cards/GroupCard';
import {Group} from '../../graphql';

interface GroupListViewProps {
  groups: Array<Group>;
}

export const GroupListView = ({groups}: GroupListViewProps) => {
  const cs = CardStyles();

  return (
    <>
      <Link to="/group/new" className={cs.fabTop}>
        <Fab size="large" color="primary">Add</Fab>
      </Link>

      <Grid container spacing={2} className={cs.root}>
        {groups.map((group: Group) => (
          <Grid item md={4} xs={12} key={group.id}>
            <GroupCard
              group={group}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
